import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { PathwayProgressIcon, SortButton } from 'secondstep-components'

export const AdminSortButtonWrapper = styled.div.attrs(
  ({ isActive, monitorView }) => ({
    paddingBottom: isActive ? '0.1875rem' : '0',
    flex: monitorView ? 'none' : '1',
  }),
)`
  display: flex;
  flex: ${({ flex }) => flex};
  align-items: center;
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
`

export const StyledPathwayProgressIcon = styled(PathwayProgressIcon)``

export const StyledSortButton = styled(SortButton).attrs(({ isActive }) => ({
  caretTop: isActive ? '52%' : '44%',
}))`
  flex: none;
  position: relative;
  gap: 0;
  text-wrap: nowrap;
  color: ${themeGet('colors.darkGray')};

  .title {
    display: flex;
    align-items: center;
  }

  [class*='StyledButton'] {
    padding-left: 1.25rem;
    text-align: left;
    white-space: pre-line;
    position: relative;
  }

  [class*='StyledCaret'] {
    position: absolute;
    left: 4px;
    top: ${({ caretTop }) => caretTop};
    translateY(-50%);
  }

  ${StyledPathwayProgressIcon} {
    position: absolute;
    right: -28px;
    bottom: -1px;
  }
`
